import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system/layout';

import type { ErrorHandlerProps } from 'src/app/pages/decisionMakerResponse/details/pageContext';

export function DecisionMakerResponseErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	return (
		<Container variant="small">{`Failed to retrieve data for DecisionMakerResponse page (error: ${error})`}</Container>
	);
}
